import React, { Component, lazy, Suspense } from "react";
import { connect } from "react-redux";
import NotAnAdmin from "./NotAnAdmin";
import PageNotFound from "../PageNotFound/PageNotFound";
import "./MainContent.css";

import Loader from "../Loader/Loader";

import { Redirect, Route, Switch } from "react-router-dom";

const LoadableSpam = lazy(() => import("./Spam/Spam"));

const LodableFBComments = lazy(() => import("./FacebookComments/FacebookComments"));

const LoadablePublications = lazy(() => import("./Publications/Publications"));

const LoadableViralityAdminPanel = lazy(() => import("./ViralityThreshold/ViralityAdminPanel"));

const LoadableLoginLogs = lazy(() => import("./LoginLogs/LoginLogs"));

const LoadableWordCloud = lazy(() => import("./WordCloud/WordCloudsContainer"));

const LodableBlockSource = lazy(() => import("./BlockSource/BlockUrl"));

const LoadableUserManagement = lazy(() => import("./UserManagement/UserManagement"));

const LoadableIGConfigurations = lazy(() => import("./InstagramHashTag/InstagramHashTags"));

const LoadableImageUpload = lazy(() => import("./LogoUpload/LogoUpload"));

const LoadableFilters = lazy(() => import("./FilterSetting/FilterSetting"));

const LoadableImageAnalyticsSettings = lazy(() => import("./ImageAnalytics/ImageAnalyticsSetting"));

const LoadableImageAnalyticsLogoModal = lazy(() => import("./ImageAnalytics/LogoModal"));
const LodableUserActivityModal = lazy(() => import("./UserActivity/UserActivity"));
class SettingsContainer extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        let themeMode = this.props.themeMode;
        let settingsDisabled =
            !["enterprise"].includes(this.props.packageObj?.package_code) &&
            [
                "/settings/block-source",
                "/settings/wordcloud",
                "/settings/login-logs",
                "/settings/logo-upload",
                "/settings/image-analytics",
                "/settings/spam",
            ].includes(this.props.location?.pathname);

        return (
            <div id="mainContent" className={`${themeMode} ${"mainContent"} ${this.props.sidebarExpanded ? "sidebar-expanded" : "sidebar-collapsed"}`}>
                {/* {settingsDisabled ? (
                    <NotAnAdmin {...this.props} settingsDisabled={!["enterprise"].includes(this.props.packageObj?.package_code)} />
                ) : */}
                {this.props.userRoles.includes("admin") || this.props.userRoles.includes("companyadmin") ? (
                    <Suspense fallback={<Loader />}>
                        <Switch>
                            <Route path="/settings/spam" component={LoadableSpam} />
                            <Route path="/settings/block-source" component={LodableBlockSource} />
                            <Route path="/settings/wordcloud" component={LoadableWordCloud} />
                            <Route path="/settings/user-management" component={LoadableUserManagement} />
                            <Route path="/settings/virality-threshold" component={LoadableViralityAdminPanel} />
                            {/* <Route path="/settings/login-logs" component={LoadableLoginLogs} /> */}
                            <Route path="/settings/logo-upload" component={LoadableImageUpload} />
                            <Route path="/settings/filters" component={LoadableFilters} />
                            {/* <Route path="*" render={(props) => <PageNotFound {...props} />} /> */}
                            <Route path="/settings/image-analytics" component={LoadableImageAnalyticsSettings} exact />
                            <Route path="/settings/image-analytics/train-logo" component={LoadableImageAnalyticsLogoModal} />
                            <Route
                                path="/settings/image-analytics/edit-logo"
                                render={(props) => <LoadableImageAnalyticsLogoModal {...props} isEditPage={true} />}
                            />
                            <Route path="/settings/activity-logs" component={LodableUserActivityModal} />
                            <Redirect to="/settings/block-source" />
                        </Switch>
                    </Suspense>
                ) : (
                    <NotAnAdmin {...this.props} />
                )}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        themeMode: state.globalReducer.themeMode,
        sidebarExpanded: state.globalReducer.sidebarExpanded,
        company: state.globalReducer.company,
        userRoles: state.globalReducer.user.roles,
        packageObj: state.globalReducer.packageObj,
    };
};

export default connect(mapStateToProps)(SettingsContainer);
